// Module
var code = "<div class=\"pull-left\">| 0%</div><div class=\"pull-right\">100% |</div>\n";
// Exports
module.exports = code;